export const SHOW_MODAL = 'modal/SHOW_MODAL'
export const SET_MODAL_CATEGORY = 'modal/SET_MODAL_CATEGORY'
